import script from "./CrudPigmentos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudPigmentos.vue?vue&type=script&setup=true&lang=js"

import "./CrudPigmentos.vue?vue&type=style&index=0&id=2bf90ca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf90ca2"]])

export default __exports__